import React, { Component } from "react";
import { HotTable } from "@handsontable/react";
import { utils } from "~/utils";
import * as _ from "lodash";

class OETBasicInfo extends Component {
    constructor(props) {
        super(props);
        this.hotTableComponent = React.createRef();
    }

    render() {
        const { oet, status } = this.props;
        const data = oet ? this.getTestData(oet) : [];
        const table_op = {
            width: "100%",
            height: 500,
            stretchH: "all",
            beforeChange: this.onBeforeHotChange,
            settings: {
                tableClassName: ["table", "table-bordered", "table-striped"],
                fillHandle: true,
                // disableVisualSelection: true,
                wordWrap: true,
                stretchH: "none",
                className: "htCenter htMiddle",
                colHeaders: this.getColHeaders(status),
                columns: this.getColumns(status),
                data
            }
        };
        return (
            <div>
                <HotTable currentHeaderClassName="thead-dark" ref={this.hotTableComponent} {...table_op} />
            </div>
        );
    }

    onBeforeHotChange = (changes, source) => {
        const hot = this.hotTableComponent.current.hotInstance;
        if (source === "edit") {
            const { oet, onItemsChange } = this.props;
            const [row, key, , newValue] = changes[0];
            const dataRow = hot.getSourceDataAtRow(row);
            const oldItem = oet.items.find(item => item.id === dataRow.id);
            let newItem = null;
            if (oldItem.hasOwnProperty(key)) {
                newItem = Object.assign({}, oldItem);
                newItem[key] = newValue;
            }
            onItemsChange({ oldItem, newItem });
        }
    };

    getColHeaders = () => [
        "Project",
        "Circle",
        "PO No.",
        "PO Date",
        "Activity End Date",
        "CUSTOMER PO<br/>LINE ITEM No.",
        "Item <br/>Group",
        "Customer Material<br/>Code/No.",
        "Customer PO line<br/>item Description",
        "Unit Rate<br/>INR",
        "PO QTY",
        "PAID/FOC",
        "Bypass<br/>date",
        "Bypass<br/>by",
        ""
    ];

    getColumns = status => {
        // const is_editable = !(status > 0);
        return [
            {
                data: "project",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "circle",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "number",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "date",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "activity_end_date",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "item",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "group",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "code",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "description",
                width: 250,
                editor: false,
                className: "htJustify"
            },
            {
                data: "unit_rate",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "quantity",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "paid_foc",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "bypass_date",
                editor: false,
                className: "htMiddle htCenter"
            },
            {
                data: "bypassed_by",
                editor: false,
                className: "htMiddle htCenter"
            }
        ];
    };

    getTestData = oet => {
        const { itemID } = this.props;
        const { items, cpo_data, customer_purchase_order } = oet;
        let filterItems = [];
        if (items) {
            filterItems = [...items];
            if (itemID) {
                filterItems = filterItems.filter(item => parseInt(item.id, 10) === parseInt(itemID, 10));
            }
        }
        filterItems = filterItems.filter(item => item.cancelled === false)
        if (items) {
            return _.orderBy(filterItems, ["item"], ["asc"]).map(item => ({
                ...item,
                project: customer_purchase_order ? customer_purchase_order.project : null,
                circle: customer_purchase_order ? customer_purchase_order.circle : null,
                number: cpo_data ? cpo_data.number : null,
                date: cpo_data ? utils.renderDate(cpo_data.date) : null,
                activity_end_date: utils.renderDate(item.activity_end_date),
                bypass_date: utils.renderDate(item.bypass_date),
                bypassed_by: item.bypassed_by ? item.bypassed_by.username : null,
                
            }));
        }
        return [{}];
    };
}

export default OETBasicInfo;
